import { render, staticRenderFns } from "./TemplateColumnTextSettings.vue?vue&type=template&id=7461ed84&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TemplateColumnTextSettings.vue?vue&type=script&lang=js&"
export * from "./TemplateColumnTextSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7461ed84')) {
      api.createRecord('7461ed84', component.options)
    } else {
      api.reload('7461ed84', component.options)
    }
    module.hot.accept("./TemplateColumnTextSettings.vue?vue&type=template&id=7461ed84&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('7461ed84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/TemplateColumnTextSettings.vue"
export default component.exports